import {
  SHIFT_CREATE_GET, SHIFT_CREATE_GET_SUCCESS, SHIFT_CREATE_GET_FAILURE,
  SHIFT_CREATE_UPDATE, SHIFT_CREATE_UPDATE_FAILURE, SHIFT_CREATE_UPDATE_SUCCESS,
  DOWNLOAD_SHIFT, DELETE_SHIFT_FILE
} from './mutation-types'

export default {
  state: {
    shift_dates: [],
    shifts: [],
    shift_shop_configurations: [],
    shift_class_haya_ho: [],
    shift_class_haya_ka: [],
    shift_class_naka_ho: [],
    shift_class_oso_ho: [],
    shift_class_oso_ka: [],
    shift_class_kyuka: [],
    shift_class_sonota: [],
    shifts_renkin_checkdatas: []
  },
  getters: {
    shift_dates: state => {
      return state.shift_dates
    },
    shifts: state => {
      return state.shifts
    },
    shift_shop_configurations: state => {
      return state.shift_shop_configurations
    },
    shift_class_haya_ho: state => {
      return state.shift_class_haya_ho
    },
    shift_class_haya_ka: state => {
      return state.shift_class_haya_ka
    },
    shift_class_naka_ho: state => {
      return state.shift_class_naka_ho
    },
    shift_class_oso_ho: state => {
      return state.shift_class_oso_ho
    },
    shift_class_oso_ka: state => {
      return state.shift_class_oso_ka
    },
    shift_class_kyuka: state => {
      return state.shift_class_kyuka
    },
    shift_class_sonota: state => {
      return state.shift_class_sonota
    },
    shifts_renkin_checkdatas: state => {
      return state.shifts_renkin_checkdatas
    }
  },
  actions: {
    [SHIFT_CREATE_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/master/shifts', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CREATE_GET_FAILURE, res.data)
          } else {
            commit(SHIFT_CREATE_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHIFT_CREATE_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shifts/' + params.id
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CREATE_UPDATE_FAILURE, { data: data, callback: callback })
          } else {
            commit(SHIFT_CREATE_UPDATE_SUCCESS, { data: data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    async [DOWNLOAD_SHIFT] ({ dispatch }, params) {
      const res = await dispatch('apiGet', {url: '/master/shifts/download', data: params.data})
      if (res.status !== 200 && res.status !== 204) {
        console.error(res.status)
      }
      return res.data
    },
    async [DELETE_SHIFT_FILE] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/master/shifts/delete_file', data: params.data })
      return res.data
    }
  },
  mutations: {
    [SHIFT_CREATE_GET_FAILURE] (state, data) {
      console.log('SHIFT_CREATE_GET_FAILURE')
    },
    [SHIFT_CREATE_GET_SUCCESS] (state, data) {
      console.log('SHIFT_CREATE_GET_SUCCESS')
      state.shift_dates = data.data.shift_dates
      state.shifts = data.data.shifts
      state.shift_shop_configurations = data.data.shift_shop_configurations
      state.shift_class_haya_ho = data.data.shift_class_haya_ho
      state.shift_class_haya_ka = data.data.shift_class_haya_ka
      state.shift_class_naka_ho = data.data.shift_class_naka_ho
      state.shift_class_oso_ho = data.data.shift_class_oso_ho
      state.shift_class_oso_ka = data.data.shift_class_oso_ka
      state.shift_class_kyuka = data.data.shift_class_kyuka
      state.shift_class_sonota = data.data.shift_class_sonota
      state.shifts_renkin_checkdatas = data.data.shifts_renkin_checkdatas
      if (data.callback) {
        data.callback()
      }
    },
    [SHIFT_CREATE_UPDATE_FAILURE] (state, params) {
      console.log('SHIFT_CREATE_UPDATE_FAILURE')
      if (params.callback) {
        params.callback('error')
      }
    },
    [SHIFT_CREATE_UPDATE_SUCCESS] (state, params) {
      console.log('SHIFT_CREATE_UPDATE_SUCCESS')
      if (params.callback) {
        params.callback('success')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift-create.js